import { ICurrencyPayload, ICountryPayload } from './types';

export const ActionTypes = {
  OPEN_COUNTRIES_CURRENCIES_SETTINGS: 'settings/open_country_currencies_settings',
  CLOSE_COUNTRIES_CURRENCIES_SETTINGS: 'settings/close_country_currencies_settings',
  FETCH_ALL_COUNTRIES_CURRENCIES: 'settings/fetch_all_country_currencies',
  INTERNATIONALIZATION_PROCESSING: 'settings/internationalization_processing',
  INTERNATIONALIZATION_SUCCESS: 'settings/internationalization_success',
  INTERNATIONALIZATION_FAILED: 'settings/internationalization_failed',
  SET_INTERNATIONALIZATION_SUCCESS: 'settings/set_internationalization_success',
  UPDATE_CURRENCY: 'settings/update_currency',
  UPDATE_COUNTRY: 'settings/update_country',
  ALLOW_XHR_REQUESTS: 'settings/allow_xhr_requests',
};

export const getData = () => ({
  type: ActionTypes.FETCH_ALL_COUNTRIES_CURRENCIES,
  payload: true,
});

export const openCountryCurrencySettings = () => ({
  type: ActionTypes.OPEN_COUNTRIES_CURRENCIES_SETTINGS,
});

export const closeCountryCurrencySettings = () => ({
  type: ActionTypes.CLOSE_COUNTRIES_CURRENCIES_SETTINGS,
});

export const updateCurrency = (payload: ICurrencyPayload) => ({
  type: ActionTypes.UPDATE_CURRENCY,
  payload,
});

export const updateCountry = (payload: ICountryPayload) => ({
  type: ActionTypes.UPDATE_COUNTRY,
  payload,
});

export const allowXHRRequests = () => ({
  type: ActionTypes.ALLOW_XHR_REQUESTS,
});
